import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const LanguageProvider = ({ children }) => {
  const { i18n } = useTranslation();

  useEffect(() => {
    // Set the HTML dir attribute for RTL support
    document.documentElement.dir = i18n.language === 'ar' ? 'rtl' : 'ltr';
    
    // Add language class to body for CSS targeting
    document.body.classList.remove('lang-ar', 'lang-en');
    document.body.classList.add(`lang-${i18n.language}`);
  }, [i18n.language]);

  return <>{children}</>;
};

export default LanguageProvider;